var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAudioTrack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-328 -668) translate(40 667) translate(288 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13 9.343c0-.397-.322-.719-.719-.719H1.72c-.397 0-.719.322-.719.719 0 .397.322.719.719.719H12.28c.397 0 .719-.322.719-.72zm-6.719 3.031H1.72c-.397 0-.719.322-.719.72 0 .396.322.718.719.718H6.28c.397 0 .719-.322.719-.719 0-.397-.322-.719-.719-.719zM13 5.592c0-.397-.322-.718-.719-.718H1.72c-.397 0-.719.321-.719.718 0 .397.322.72.719.72H12.28c.397 0 .719-.323.719-.72zm8.113-4.52l-4.339 1.432c-.57.19-.962.74-.962 1.37v13.022c-.913-.667-2.184-1.084-3.593-1.084-2.78 0-5.031 1.61-5.031 3.594 0 1.985 2.252 3.594 5.03 3.594 2.78 0 5.032-1.61 5.032-3.594V9.624l4.767-1.589c.587-.196.983-.745.983-1.364V2.436c0-.46-.222-.894-.595-1.163-.374-.27-.854-.345-1.292-.201zm-8.894 20.49c-2.118 0-3.594-1.136-3.594-2.156 0-1.02 1.476-2.156 3.594-2.156 2.117 0 3.594 1.136 3.594 2.156 0 1.02-1.477 2.156-3.594 2.156zm9.344-14.89L17.25 8.108V3.874h-.025v-.006l4.337-1.432V6.67z",
    transform: "translate(-328 -668) translate(40 667) translate(288 1)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioTrack);
export default __webpack_public_path__ + "static/media/iconAudioTrack.fe259b20.svg";
export { ForwardRef as ReactComponent };